// =============================================================================
// TYMCZASOWE UWAGI DO KARNETÓW - DO USUNIĘCIA
// Aby usunąć: usuń ten plik oraz importy oznaczone komentarzem // TEMP_PASS_NOTICES
// (PassTag, PassesList, PassDetailsModal, TicketDetailsModal, DetailsSwimmingProgress)
// =============================================================================

// Uwagi przypisane do kolejnych karnetów na liście aktywnych (indeks 0 = pierwszy, 1 = drugi itd.)
export const TEMP_PASS_NOTICES: string[] = [
  "Dziecko biega i hałasuje",
  "Karnet został zawieszony",
];

// TEMP_PASS_NOTICES — komunikat o odrobieniu w sekcji postępu szkółki (passtype 9)
export const TEMP_SWIMMING_MAKEUP_ENABLED = true;

const getTerminPlural = (count: number): string => {
  if (count === 1) return "termin";
  const mod10 = count % 10;
  const mod100 = count % 100;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return "terminy";
  return "terminów";
};

/** Zwraca tekst chipa gdy wykorzystano mniej niż limit wejść (np. 3/10). */
export const getTempSwimmingMakeupMessage = (used: number, total: number): string | null => {
  if (!TEMP_SWIMMING_MAKEUP_ENABLED || total <= 0 || used >= total) return null;
  const remaining = total - used;
  return `Masz ${remaining} ${getTerminPlural(remaining)} do odrobienia w ramach Twojej grupy zajęciowej`;
};
